import { PageHero } from "../components/PageHero";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/content";

const Block = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-heading text-navy-900 mb-3">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function Datenschutz() {
  return (
    <>
      <Seo title="Datenschutzerklärung" description="Datenschutzerklärung von Energie-Tarifberater – Informationen zur Verarbeitung Ihrer Daten gemäß DSGVO." path="/datenschutz" />
      <PageHero
        eyebrow="Rechtliches"
        titleLines={["Datenschutz"]}
        breadcrumb={[{ label: "Datenschutz" }]}
      />
      <section className="bg-background py-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-10">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-10">Ihre Daten sind bei uns sicher</p>

            <Block title="1. Verantwortlicher">
              <p>
                {CONTACT.responsible}, im Auftrag der EED Vertriebs GmbH, {CONTACT.street}, {CONTACT.city}.
                Kontakt:{" "}
                <a href={CONTACT.emailHref} className="text-blue-700 hover:underline">{CONTACT.email}</a>.
              </p>
            </Block>

            <Block title="2. Verarbeitung Ihrer Daten">
              <p>
                Wir verarbeiten personenbezogene Daten (Name, E-Mail, Telefonnummer und hochgeladene Energieabrechnungen)
                ausschließlich zur Durchführung der kostenlosen Rechnungsanalyse und Angebotserstellung.
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung/Durchführung eines Vertrags) sowie
                lit. a DSGVO (Ihre Einwilligung).
              </p>
            </Block>

            <Block title="3. Rechnungs-Upload & Auswertung">
              <p>
                Von Ihnen hochgeladene Abrechnungen werden zur Auswertung verarbeitet. Die enthaltenen Werte werden
                zur Erstellung Ihres individuellen Angebots analysiert. Ihre Unterlagen werden nach Abschluss der
                Beratung gelöscht und nicht an unbefugte Dritte weitergegeben.
              </p>
            </Block>

            <Block title="4. Speicherdauer">
              <p>
                Ihre Daten werden nur so lange gespeichert, wie es für die Angebotserstellung und die anschließende
                Betreuung erforderlich ist bzw. gesetzliche Aufbewahrungsfristen dies vorschreiben.
              </p>
            </Block>

            <Block title="5. Ihre Rechte">
              <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
                Datenübertragbarkeit sowie Widerspruch. Eine erteilte Einwilligung können Sie jederzeit mit Wirkung
                für die Zukunft widerrufen. Wenden Sie sich hierzu an{" "}
                <a href={CONTACT.emailHref} className="text-blue-700 hover:underline">{CONTACT.email}</a>.
              </p>
            </Block>

            <Block title="6. Beschwerderecht">
              <p>
                Ihnen steht das Recht zu, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
                personenbezogenen Daten zu beschweren.
              </p>
            </Block>
          </Reveal>
        </div>
      </section>
    </>
  );
}
